
import { Routes } from '@angular/router';
import { generalStateGuard } from './general-state/general-state.guard';
import { roleGuard, adminOnlyCanMatch, marketerOnlyCanMatch } from './shared/guards/role.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'config',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [generalStateGuard],
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'home',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },

  // ══════ Rutas solo admin (canMatch → inexistentes para marketer) ══════
  // data.roles: no lo consume roleGuard (estas rutas no lo llevan) — lo usa
  // RoleAwarePreloadingStrategy para NO descargar estos chunks a marketers.
  {
    path: 'pos',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadComponent: () => import('./pages/pos/pos.page').then( m => m.PosPage)
  },
  {
    path: 'payment',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    loadComponent: () => import('./pages/placeholder/placeholder.page').then( m => m.PlaceholderPage),
    data: {
      roles: ['admin'],
      titleKey: 'PAYMENT.TITLE',
      icon: 'card-outline',
      emptyTitleKey: 'PAYMENT.EMPTY_TITLE',
      emptyBodyKey: 'PAYMENT.EMPTY_BODY',
    },
  },
  {
    path: 'shipping',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    loadComponent: () => import('./pages/placeholder/placeholder.page').then( m => m.PlaceholderPage),
    data: {
      roles: ['admin'],
      titleKey: 'SHIPPING.TITLE',
      icon: 'cube-outline',
      emptyTitleKey: 'SHIPPING.EMPTY_TITLE',
      emptyBodyKey: 'SHIPPING.EMPTY_BODY',
    },
  },
  {
    path: 'product',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/product/product-routes').then( m => m.PRODUCT_ROUTES)
  },
  {
    path: 'customer',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    loadComponent: () => import('./pages/placeholder/placeholder.page').then( m => m.PlaceholderPage),
    data: {
      roles: ['admin'],
      titleKey: 'CUSTOMER.TITLE',
      icon: 'people-outline',
      emptyTitleKey: 'CUSTOMER.EMPTY_TITLE',
      emptyBodyKey: 'CUSTOMER.EMPTY_BODY',
    },
  },
  {
    path: 'route',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/route/route.routes').then( m => m.ROUTE_ROUTES),
  },
  {
    path: 'marketer',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/marketer/marketer-routes').then( m => m.MARKETER_ROUTES),
  },
  {
    path: 'scanner',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadComponent: () => import('./pages/scanner/scanner.page').then( m => m.ScannerPage)
  },
  {
    path: 'reports',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadComponent: () => import('./pages/reports/reports.page').then(m => m.ReportsPage)
  },
  {
    path: 'sales-point',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/sales-point/sales-point-routes').then(m => m.SALES_POINT_ROUTES),
  },
  {
    path: 'chain',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/chain/chain.routes').then(m => m.CHAIN_ROUTES),
  },
  {
    path: 'perfect-store',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadChildren: () => import('./pages/perfect-store/perfect-store.routes').then(m => m.PERFECT_STORE_ROUTES),
  },
  {
    path: 'permissions',
    canMatch: [adminOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['admin'] },
    loadComponent: () => import('./pages/permissions/permissions.page').then( m => m.PermissionsPage)
  },

  // ══════ Rutas solo marketer ══════
  {
    path: 'visit',
    canMatch: [marketerOnlyCanMatch],
    canActivate: [generalStateGuard],
    data: { roles: ['marketer'] },
    loadChildren: () => import('./pages/visit/visit.routes').then( m => m.VISIT_ROUTES)
  },

  // ══════ Rutas compartidas (ambos roles) — roleGuard filtra ══════
  {
    path: 'dashboard',
    canActivate: [generalStateGuard, roleGuard],
    data: { roles: ['admin', 'marketer'] },
    loadComponent: () => import('./pages/dashboard/dashboard.page').then( m => m.DashboardPage),
  },
  {
    path: 'setting',
    canActivate: [generalStateGuard, roleGuard],
    data: { roles: ['admin', 'marketer'] },
    loadComponent: () => import('./pages/setting/setting.page').then( m => m.SettingPage)
  },

  // ══════ Rutas de onboarding (sin rol) ══════
  {
    path: 'config',
    canActivate: [generalStateGuard],
    loadComponent: () => import('./pages/config/config.page').then( m => m.ConfigPage)
  },

  // ══════ Wildcard — redirige al dashboard (el state machine acota) ══════
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
